import { render, staticRenderFns } from "./ModernAntimatterDimensionsTab.vue?vue&type=template&id=580efe87&scoped=true"
import script from "./ModernAntimatterDimensionsTab.vue?vue&type=script&lang=js"
export * from "./ModernAntimatterDimensionsTab.vue?vue&type=script&lang=js"
import style0 from "./ModernAntimatterDimensionsTab.vue?vue&type=style&index=0&id=580efe87&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "580efe87",
  null
  
)

export default component.exports